import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const fotoEpisodesSchema = new schema.Entity('fotoEpisodesContainer', {
    fotoEpisodes: [schemas.fotoEpisodes],
    fotoSurveys: [schemas.fotoSurveys],
    PTOUTMEASURES: [schemas.PTOUTMEASURES],
    FOTOPATIENTRESPONSE: [schemas.FOTOPATIENTRESPONSE]
});

